import { useDictionary, useItems } from "@adamlip/okeoke.client"
import { AppParamsContext } from "contexts/AppParamsContext"
import CategoryCard from "./CategoryCard"
import { useContext, useEffect, useState } from "react"

export default function HomeScreenCategories() {
  const { getValue } = useDictionary()
  const { appParams } = useContext(AppParamsContext)

  const { categoryTree, categories } = useItems()
  const [filteredCategories, setFilteredCategories] = useState([])

  useEffect(() => {
    let filtered = []
    if (appParams?.styles?.homePage?.categoriesToShow === "onlySub") {
      categoryTree?.forEach((category) => {
        category?.categories?.forEach((subCategory) => {
          if (
            categories[subCategory?.uuid]?.enabled &&
            (subCategory.availability?.availableItems > 0 ||
              subCategory.availability?.availableSubItems > 0) &&
            (subCategory.availability?.visibleItems > 0 ||
              subCategory.availability?.visibleSubItems > 0)
          ) {
            console.log("pushed", subCategory)
            filtered.push(subCategory)
          }
        })
      })
    } else if (
      appParams?.styles?.homePage?.categoriesToShow === "onlyMain" ||
      appParams?.styles?.homePage?.categoriesToShow == null
    ) {
      categoryTree?.forEach((category) => {
        if (
          categories[category?.uuid]?.enabled &&
          (category.availability?.availableItems > 0 ||
            category.availability?.availableSubItems > 0) &&
          (category.availability?.visibleItems > 0 ||
            category.availability?.visibleSubItems > 0)
        ) {
          filtered.push(category)
        }
      })
    } else if (appParams?.styles?.homePage?.categoriesToShow === "both") {
      categoryTree?.forEach((category) => {
        if (
          categories[category?.uuid]?.enabled &&
          (category.availability?.availableItems > 0 ||
            category.availability?.availableSubItems > 0) &&
          (category.availability?.visibleItems > 0 ||
            category.availability?.visibleSubItems > 0)
        ) {
          filtered.push(category)
        }
        category?.categories?.forEach((subCategory) => {
          if (
            categories[subCategory?.uuid]?.enabled &&
            (subCategory.availability?.availableItems > 0 ||
              subCategory.availability?.availableSubItems > 0) &&
            (subCategory.availability?.visibleItems > 0 ||
              subCategory.availability?.visibleSubItems > 0)
          ) {
            filtered.push(subCategory)
          }
        })
      })
    }
    setFilteredCategories(filtered)
  }, [categoryTree, categories, appParams])
  if (filteredCategories.length < 1) return null

  return (
    <div className="p-3">
      <p className="text-lg font-bold mb-2">
        {getValue("app_v2_categories_homeScreen")}
      </p>
      <div
        className={`${
          appParams?.styles?.homePage?.categoriesLayout === "list"
            ? "w-full flex flex-row gap-2 overflow-x-scroll pb-4"
            : "flex flex-wrap gap-2 justify-center"
        }`}
      >
        {filteredCategories?.map((category) => {
          return (
            <CategoryCard
              key={category.uuid}
              showImage={appParams?.styles?.homePage?.showCategoriesImage}
              category={category}
              categories={categories}
              layout={appParams?.styles?.homePage?.categoriesLayout}
            />
          )
        })}
      </div>
    </div>
  )
}
